import { css } from "styled-components";

export const glassMixin = css`
    background: linear-gradient(
        145deg,
        rgba(255, 255, 255, 0.72) 0%,
        rgba(255, 255, 255, 0.48) 40%,
        rgba(255, 255, 255, 0.36) 100%
    );
    backdrop-filter: blur(28px) saturate(220%) brightness(1.08);
    -webkit-backdrop-filter: blur(28px) saturate(220%) brightness(1.08);
    border: 1px solid rgba(255, 255, 255, 0.9);
    box-shadow:
        0 2px 0 0 rgba(255, 255, 255, 0.95) inset,
        0 -1px 0 0 rgba(255, 255, 255, 0.3) inset,
        1px 0 0 0 rgba(255, 255, 255, 0.55) inset,
        -1px 0 0 0 rgba(255, 255, 255, 0.55) inset,
        0 12px 40px rgba(0, 0, 0, 0.12),
        0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const darkGlassMixin = css`
    background: linear-gradient(
        145deg,
        rgba(255, 255, 255, 0.14) 0%,
        rgba(255, 255, 255, 0.07) 40%,
        rgba(255, 255, 255, 0.04) 100%
    );
    backdrop-filter: blur(32px) saturate(180%) brightness(1.04);
    -webkit-backdrop-filter: blur(32px) saturate(180%) brightness(1.04);
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow:
        0 2px 0 0 rgba(255, 255, 255, 0.22) inset,
        0 -1px 0 0 rgba(255, 255, 255, 0.06) inset,
        1px 0 0 0 rgba(255, 255, 255, 0.1) inset,
        -1px 0 0 0 rgba(255, 255, 255, 0.1) inset,
        0 16px 48px rgba(0, 0, 0, 0.4),
        0 4px 12px rgba(0, 0, 0, 0.24);
`;
